<template>
  <div class="searchwrapper">
    <form v-on:submit.prevent="search" role="search" id="gallerisearch">
      <div class="searchfield input-group">
        <input
          name="q"
          id="gallerisearchfield"
          class="form-control"
          type="text"
          :placeholder="$texts.sok"
          :aria-label="$texts.sokfalt"
          v-model="query"
          autocomplete="off"
          @input="onInput"
        />
        <button
          id="gallerisearchfieldClear"
          type="reset"
          :class="[this.showClearBtn ? '' : 'd-none', 'btn-reset']"
          @click="clearInput"
        >
          <Icon :type="'cross'"></Icon>
          <span class="visually-hidden">{{ $texts.taBortText }}</span>
        </button>
        <button
          ref="submitgallerisearch"
          id="gallerisearchfieldButton"
          type="submit"
          class="btn-search"
        >
          <Icon :type="'search'"></Icon>
          <span class="visually-hidden">{{ $texts.sok }}</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Icon from "common/js/vue/image/icon.vue";

export default {
  name: "GalleriSearchField",
  props: {
    baseApiUrl: String,
    queryString: String,
  },
  data: function () {
    return {
      query: "",
      inputText: "",
      showClearBtn: false,
    };
  },
  inject: {
    galleriService: "galleriService",
    getItems: "getItems",
    getPage: "getPage",
  },
  created() {
    this.query = this.queryString;
    if (this.query.length > 0) {
      this.showClearBtn = true;
    }
  },
  components: {
    Icon,
  },
  methods: {
    clearInput() {
      this.query = "";
      this.autoCompleteItems = [];
      this.showClearBtn = false;
      this.search("clear");
    },
    onInput() {
      this.inputText = this.query;
      if (this.query.length == 0) {
        this.clearInput();
        document.getElementById("gallerisearchfield").focus();
      } else if (this.query.length > 0) {
        this.showClearBtn = true;
      }
    },
    search(ops) {
      let usp = new URLSearchParams(window.location.search);
      let searchObj = this.$searchObj;
      if (_.isEqual(ops, "clear")) {
        usp.delete("q");
      } else {
        usp.set("q", this.query);
        searchObj.filtering = true;
      }

      usp.set("page", 1);
      history.replaceState(null, null, "?" + usp.toString());

      searchObj.query = this.query;
      this.getItems(searchObj);
    },
  },
};
</script>
